// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3XsQH","detailsBorder":"styles_detailsBorder__1isSF"};